import styled from "styled-components";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { useInvoiceStore } from "../store/invoice-store";
import { useTranslation, Trans } from "react-i18next";
import { redirectToAuth } from "@/pages/profile/helper/redirectToAuth";
import { useGlobalStore } from "@/store/GlobalStore";

export function InvoiceTip() {
  const { showInvoiceTip, setShowInvoiceTip } = useInvoiceStore();
  const t = getTranslateNsT("invoice");
  const { t: trans } = useTranslation("invoice");
  const { userInfo } = useGlobalStore();

  if (!showInvoiceTip) return null;
  return (
    <InvoiceTipWrapper>
      <InvoiceTipHeader>
        <span>{t("invoice_recharge_tip_title")}</span>
        <CloseIcon onClick={() => setShowInvoiceTip(false)} />
      </InvoiceTipHeader>
      <InvoiceTipContent>
        <div>{t("invoice_recharge_padding_payment_tip1")}</div>
        <Trans
          i18nKey="invoice_recharge_padding_payment_tip2"
          t={trans}
          components={{
            span: (
              <span
                onClick={() =>
                  redirectToAuth(
                    userInfo,
                    false,
                    "/authenticate/enterprise-authenticate"
                  )
                }
              />
            ),
          }}
        ></Trans>
        <div>{t("invoice_recharge_padding_payment_tip3")}</div>
        <div>{t("invoice_recharge_padding_payment_tip4")}</div>
        <div>{t("invoice_recharge_padding_payment_tip5")}</div>
        <div>{t("invoice_recharge_padding_payment_tip6")}</div>
      </InvoiceTipContent>
    </InvoiceTipWrapper>
  );
}

const InvoiceTipWrapper = styled.div`
  border-radius: 4px;
  border: 1px solid #343538;
  background: #292b2f;
  min-width: 386px;
  width: 386px;
`;

const InvoiceTipHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 46px;
  padding-left: 12px;
  border-bottom: 1px solid #404246;
`;

const CloseIcon = styled.span`
  position: relative;
  width: 16px;
  height: 16px;
  right: 14px;
  transform: rotate(45deg);
  cursor: pointer;
  &::before {
    height: 100%;
    content: "";
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    border-left: 1px solid #778086;
  }
  &::after {
    width: 100%;
    content: "";
    position: absolute;
    bottom: 50%;
    transform: translate(0, 50%);
    border-bottom: 1px solid #778086;
  }
`;

const InvoiceTipContent = styled.div`
  padding: 16px 12px;
  color: #b3bac0;
  line-height: 20px;
  span {
    color: var(--main-color);
    text-decoration: underline;
    cursor: pointer;
  }
`;
